const INITIAL_STATE = {
	aguardando: false,
	registro: {},
	modoTela: 'lista',
	lista: [],
	listaGrupo: [],
	listaCnh: [],
	listaCpf: [],
	consultaCPF: null,
	consultaCNH: null
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
		case 'MOTORISTA_MODO_TELA':
            return { ...state,
				modoTela: action.payload.modo,
				registro: action.payload.registro
			};

		case 'MOTORISTA_SET_AGUARDANDO':
            return { ...state,
				aguardando: action.payload
			};

        case 'MOTORISTA_LISTADO':
            return {
				...state,
				lista: action.payload.data
			};

        case 'MOTORISTA_CNH_LISTADO':
            return {
				...state,
				listaCnh: action.payload.data
			};

        case 'MOTORISTA_CPF_LISTADO':
            return {
				...state,
				listaCpf: action.payload.data
			};

        case 'MOTORISTA_GRUPO_SELECT_LISTADO':
			return {
				...state,
				listaGrupo: action.payload.data
			};

		case 'MOTORISTA_VALIDACAO_CPF_LISTADO':
			return {
				...state,
				consultaCPF: action.payload.data
			}

		case 'MOTORISTA_VALIDACAO_CNH_LISTADO':
			return {
				...state,
				consultaCNH: action.payload.data
			}

        default:
            return state;
    }
}
